import React from 'react';
import RDsNatureRetreat2025  from 'views/RDsNatureRetreat2025';

const LifeSkillPage = () => {
  return <RDsNatureRetreat2025/>;
};

export default LifeSkillPage;
